import { Injectable } from '@angular/core';
import { ThemingService } from './theming.service';
import { saveAs } from 'file-saver';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import * as XLSX from 'xlsx';

interface Beneficiary {
  name: string;
  lastname: string;
  relation: string;
  bornDate: string;
  phone?: string;
  gender?: string;
  nationalId?: string;
  email?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExportSuppliersService {

  shopName = "";

  constructor(
    private themingService: ThemingService
  ) {
    this.extractShopName();
  }

  ngOninit(){

  }

  private extractShopName(): void {
    const themingData: any = (this.themingService as any)?.shopTheming;

    if (Array.isArray(themingData) && themingData.length > 0) {
      this.shopName = themingData[0]?.shopName || 'Desconocido';
    } else {
      console.error('ThemingService no tiene shopTheming válido.');
    }
  }

  exportToFile(
    data: any[],
    supplierId: number,
    format: 'excel' | 'json' | 'csv' | 'txt'
  ): void {
    if (!data || data.length === 0) {
      console.error('No hay datos para exportar.');
      return;
    }
    return this.finalizeExport(data, supplierId, format, []);
  }

  private finalizeExport(
    data: any[],
    supplierId: number,
    format: string,
    regionData: any[]
  ): void {
    let formattedData: any[] = [];
    let fileName = "Reporte";

    if (format === 'json' || format === 'txt') {
      //formattedData = this.formatForJson(data, regionData);
    } else {
      formattedData = this.formatForExcel(data, supplierId);
    }

    if([18].includes(supplierId)){
      fileName = "Funerario"
    }

    switch (format) {
      case 'excel':
        this.exportToExcel(formattedData, fileName);
        break;
      case 'json':
        //this.exportToJson(formattedData, fileName);
        break;
      case 'csv':
        //this.exportToCsv(formattedData, fileName);
        break;
      case 'txt':
        //this.exportToTxt(formattedData, fileName);
        break;
      default:
        console.error('Formato no soportado.');
    }
  }

  private formatForExcel(data: any[], supplierId: number): any[] {
    const formattedData: any[] = [];

    data.forEach((client) => {
      console.log("Cliente:");
      console.table(client);
      let beneficiaries: Beneficiary[] = [];

      if (typeof client.beneficiaries === 'string') {
        try {
          beneficiaries = JSON.parse(client.beneficiaries);
        } catch (error) {
          console.error('Error al parsear beneficiaries:', error);
        }
      } else if (Array.isArray(client.beneficiaries)) {
        beneficiaries = client.beneficiaries;
      }

      
      
      // switch (supplierId) {
      //   //Funerario
      //   case 18:
      //     formattedData.push({
      //       Nombre_cuenta: 'Colaboradores ComerSeguros',
      //       Corredor: '',
      //       Id_Cliente_Titular: client.client.nationalId,
      //       Numero_Identificacion: client.client.nationalId,
      //       'Tipo Cliente(Parentezco)': 'Titular',
      //       Nombre: client.client.firstName,
      //       Apellido: client.client.lastName || '',
      //       'Fecha de Nacimiento': client.client.bornDate,
      //       Sexo: client.client.gender || '',
      //       Categoria: '',
      //       'Fecha Alta': client.saleDate,
      //       'Fecha Baja': '',
      //       'Tipo Plan': '',
      //       Funerario: 'Si-Titular',
      //       'Tipo Plan Funerario': client.itemCode
      //     });
      //     break;
      //   //EM
      //   case 19:
      //     formattedData.push({
      //       Nombre_cuenta: 'Colaboradores ComerSeguros',
      //       Corredor: '',
      //       Id_Cliente_Titular: client.client.nationalId,
      //       Numero_Identificacion: client.client.nationalId,
      //       'Tipo Cliente(Parentezco)': 'Titular',
      //       Nombre: client.client.firstName,
      //       Apellido: client.client.lastName || '',
      //       'Fecha de Nacimiento': client.client.bornDate,
      //       'Teléfono': '',
      //       Provincia: '',
      //       'Cantón': '',
      //       Distrito: '',
      //       'Dirección': '',
      //       Sexo: client.client.gender || '',
      //       Categoria: '',
      //       'Fecha Alta': '',
      //       'Fecha Baja': '',
      //       'Tipo Plan': '',
      //       EM: '',
      //     });
      //     break;
      //   //BESTCARE
      //   case 20:
      //     formattedData.push({
      //       Nombre_cuenta: 'Colaboradores ComerSeguros',
      //       Corredor: '',
      //       Id_Cliente_Titular: client.client.nationalId,
      //       Numero_Identificacion: client.client.nationalId,
      //       'Tipo Cliente(Parentezco)': 'Titular',
      //       Nombre: client.client.firstName,
      //       Apellido: client.client.lastName || '',
      //       'Fecha de Nacimiento': client.client.bornDate,
      //       'Teléfono': '',
      //       Provincia: '',
      //       'Cantón': '',
      //       Distrito: '',
      //       'Dirección': '',
      //       Sexo: client.client.gender || '',
      //       Categoria: '',
      //       'Fecha Alta': '',
      //       'Fecha Baja': '',
      //       'Tipo Plan': '',
      //       BC: '',
      //     });
      //     break;
      //   //SIGMA
      //   case 21:
      //     formattedData.push({
      //       Nombre_cuenta: 'Colaboradores ComerSeguros',
      //       Corredor: '',
      //       Id_Cliente_Titular: client.client.nationalId,
      //       Numero_Identificacion: client.client.nationalId,
      //       'Tipo Cliente(Parentezco)': 'Titular',
      //       Nombre: client.client.firstName,
      //       Apellido: client.client.lastName || '',
      //       'Fecha de Nacimiento': client.client.bornDate,
      //       Sexo: client.client.gender || '',
      //       Categoria: '',
      //       'Fecha Alta': '',
      //       'Fecha Baja': '',
      //       'Tipo Plan': '',
      //       'SIGMA Salud': '',
      //       'SIGMA Dental': '',
      //       'SDSIGMA': '',
      //     });
      //     break;
      //   default:
      //     break;
      // }

    if(client.hasHolder == 1){
      formattedData.push({
        Nombre_cuenta: client.shopName,
        Corredor: '',
        Id_Cliente_Titular: client.client.nationalId,
        Numero_Identificacion: client.client.nationalId,
        'Tipo Cliente(Parentesco)': 'Titular',
        Nombre: client.client.firstName,
        Apellido: client.client.lastName || '',
        'Fecha de Nacimiento': client.client.bornDate,
        'Teléfono': client.client.phone || '',
        Provincia: client.client.province || '',
        'Cantón': client.client.canton || '',
        Distrito: client.client.district || '',
        'Dirección': client.client.address || '',
        Sexo: client.client.gender || '',
        Categoria: client.variantValueName || '',
        // Categoria: client.variantValueName+""+client.variantTypeName|| '',
        'Fecha Alta': client.client.dateAssigned?client.client.dateAssigned.split(' ')[0]:'',
        'Fecha Baja': client.client.dateUnAssigned || '',
        'Tipo Plan': client.packageProductName || client.productName,
        [client.supplierName]: client.hasHolder == 1 ?'SI':'NO',
      });
    }    
      beneficiaries.forEach((beneficiary: any) => {
        formattedData.push({
          Nombre_cuenta: client.shopName,
          Corredor: '',
          Id_Cliente_Titular: client.client.nationalId,
          Numero_Identificacion: beneficiary.beneficiaryNationalId,
          'Tipo Cliente(Parentesco)': beneficiary.beneficiaryRelationship,
          Nombre: beneficiary.beneficiaryName,
          Apellido: beneficiary.beneficiaryLastName,
          'Fecha de Nacimiento': beneficiary.beneficiaryBornDate,
          'Teléfono': beneficiary.phone || '',
          Provincia: beneficiary.province || '',
          'Cantón': beneficiary.canton || '',
          Distrito: beneficiary.district || '',
          'Dirección': beneficiary.address || '',
          Sexo: beneficiary.beneficiaryGender,
          Categoria: client.variantValueName || '',
          [client.supplierName]: 'SI',
          'Fecha Alta': beneficiary.dateAssigned?beneficiary.dateAssigned.split(' ')[0]:'',
          'Fecha Baja': beneficiary.dateUnAssigned || '',
          'Tipo Plan': client.packageProductName || client.productName  ,
        });
      });
    });

    return formattedData;
  }

  private exportToExcel(data: any[], fileName: string): void {
      const worksheet = XLSX.utils.json_to_sheet(data);
      worksheet['!cols'] = [
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Clientes');
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      const file = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(file, `${fileName}.xlsx`);
    }

}

